import { useState } from 'react';
import { genreOptions, yearOptions, regionOptions } from '@/constants/filters';

interface FilterSidebarProps {
  genre: string;
  year: string;
  region: string;
  onChange: (key: 'genre' | 'year' | 'region', value: string) => void;
}

interface GroupProps {
  title: string;
  icon: string;
  options: string[];
  value: string;
  onPick: (value: string) => void;
}

function FilterGroup({ title, icon, options, value, onPick }: GroupProps) {
  return (
    <div>
      <h3 className="flex items-center gap-2 font-heading text-sm font-bold text-foreground-900">
        <i className={`${icon} text-primary-600`}></i>
        {title}
      </h3>
      <div className="mt-3 flex flex-wrap gap-2">
        {options.map((opt) => (
          <button
            key={opt}
            type="button"
            onClick={() => onPick(opt)}
            className={`rounded-full px-3 py-1.5 font-label text-xs transition-colors cursor-pointer ${
              value === opt
                ? 'bg-primary-500 text-background-50'
                : 'bg-background-200/70 text-foreground-700 hover:bg-secondary-200'
            }`}
          >
            {opt}
          </button>
        ))}
      </div>
    </div>
  );
}

export default function FilterSidebar({ genre, year, region, onChange }: FilterSidebarProps) {
  const [open, setOpen] = useState(false);

  return (
    <div className="rounded-lg border border-background-200/70 bg-background-100 p-5">
      <div className="flex items-center justify-between">
        <h2 className="flex items-center gap-2 font-heading text-base font-bold text-foreground-950">
          <i className="ri-filter-3-line text-accent-600"></i> 筛选条件
        </h2>
        <button
          type="button"
          onClick={() => setOpen((v) => !v)}
          className="flex items-center gap-1 rounded-md px-2 py-1 font-label text-xs text-foreground-600 hover:bg-background-200 lg:hidden cursor-pointer"
        >
          {open ? '收起' : '展开'}
          <i className={open ? 'ri-arrow-up-s-line' : 'ri-arrow-down-s-line'}></i>
        </button>
      </div>

      <div className={`${open ? 'mt-5 block space-y-6' : 'hidden'} lg:mt-5 lg:block lg:space-y-6`}>
        <FilterGroup title="类型" icon="ri-movie-2-line" options={genreOptions} value={genre} onPick={(v) => onChange('genre', v)} />
        <div className="border-t border-background-200/70"></div>
        <FilterGroup title="年代" icon="ri-calendar-line" options={yearOptions} value={year} onPick={(v) => onChange('year', v)} />
        <div className="border-t border-background-200/70"></div>
        <FilterGroup title="地区" icon="ri-map-pin-line" options={regionOptions} value={region} onPick={(v) => onChange('region', v)} />
      </div>
    </div>
  );
}